import { AxiosInstance, AxiosError } from "axios";

export const axiosInstances: AxiosInstance[] = [];
export const ajaxHeaders: Record<string, string> = {};

export const setAjaxHeader = (key: string, value: string | undefined): void => {
  if (value === ajaxHeaders[key]) {
    return;
  }
  if (value === undefined) {
    delete ajaxHeaders[key];
  } else {
    ajaxHeaders[key] = value;
  }
  axiosInstances.forEach((axiosInstance) => {
    try {
      if (!axiosInstance.defaults.headers) {
        throw new Error("axios instance must have defaults.headers");
      }
      if (value === undefined) {
        delete axiosInstance.defaults.headers.common[key];
      } else {
        axiosInstance.defaults.headers.common[key] = value;
      }
    } catch (error) {
      console.error("Could not set an axios instance header");
    }
  });
};

export const getAjaxHeader = (key: string): string | undefined => {
  return ajaxHeaders[key];
};

export const getIsAxiosError = (e: any): e is AxiosError => {
  return e.isAxiosError;
};
